import React from 'react';
export function ProductPresentation() {
  return <section className="py-16 px-4 max-w-4xl mx-auto text-center" data-id="element-135">
      <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-136">
        Por eso creamos esta guía.
      </h2>

      <p className="text-lg md:text-xl text-gray-700 mb-10 max-w-2xl mx-auto" data-id="element-137">
        Una guía práctica diseñada para ayudarte a entender cómo funciona tu
        sistema hormonal y cómo empezar a equilibrarlo de forma natural.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-138">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-green/10" data-id="element-139">
          <p className="font-bold text-brand-red text-xl mb-2" data-id="element-140">Sin</p>
          <p className="text-gray-700" data-id="element-141">dietas extremas.</p>
        </div>
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-green/10" data-id="element-142">
          <p className="font-bold text-brand-red text-xl mb-2" data-id="element-143">Sin</p>
          <p className="text-gray-700" data-id="element-144">tratamientos complicados.</p>
        </div>
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-brand-green/10" data-id="element-145">
          <p className="font-bold text-brand-red text-xl mb-2" data-id="element-146">Sin</p>
          <p className="text-gray-700" data-id="element-147">soluciones mágicas.</p>
        </div>
      </div>

      <div className="bg-brand-gold/10 p-8 rounded-2xl border border-brand-gold/30" data-id="element-148">
        <p className="text-xl font-medium text-brand-green" data-id="element-149">
          Solo estrategias simples basadas en alimentación, hábitos y cambios
          que realmente pueden ayudar a tu cuerpo a volver a un estado de
          equilibrio.
        </p>
        <p className="text-lg text-gray-700 mt-4" data-id="element-150">
          Con este libro vas a aprender cómo apoyar tu sistema hormonal para que
          tu cuerpo vuelva a sentirse estable, con más energía y bienestar.
        </p>
      </div>
    </section>;
}